var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tp-form-box',{staticClass:"tpf-sf-tp-form",attrs:{"formData":_vm.formData}},_vm._l((_vm.formData.formDataList),function(li,index){return _c('which-component',{key:'formData.formDataList' + index,attrs:{"data":li,"type":"ShowForm","prop":li.fieldId,"model":_vm.formData.model}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }